export const FLIP_TO_DEFAULT_TIME_MS = 8000;
